import axios from 'axios';

import { appService } from '../services/app.service';

const client = (() => axios.create({
  baseURL: appService.config.paths.api.basePath,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
}))();

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('clientToken');
  if (token) {
    config.headers.Authorization = token;
  } else {
    config.headers.Authorization = null;
  }
  console.log(`%c REQUEST: %s`, 'color: #0000FF; font-weight: bold', JSON.stringify(config));
  return config;
});

// Intercept all responses
client.interceptors.response.use(
  (response) => {
    console.log(`%c ${response.status} - ${(response.config)}:`, 'color: #008000; font-weight: bold', response);
    return response;
  },
  (error) => {
    if (error.response) {
      const config = error.response.config;
      console.log(`%c ${error.response.status} - ${JSON.stringify(config)}:`, 'color: #a71d5d; font-weight: bold', error.response);
    }
    return Promise.reject(error);
  }
);

export default client;